import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSimCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSimCard2"><Path d="M19.5 2.5H8.5L4.5 6.5V21.5H19.5V2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 2.5V7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 2.5V7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSimCard2;
